import React, { useState, useEffect } from 'react';
import { useAppSelector } from '@/shared/lib/hooks/useAppSelector';
import { selectUser } from '@/features/auth/model/authSlice';

const AccountInfoTab: React.FC = () => {
    const user = useAppSelector(selectUser);

    const [editMode, setEditMode] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        secondName: '',
        email: '',
        phone: '',
        birthDate: '',
        insuranceCompany: '',
    });

    useEffect(() => {
        if (user) {
            setFormData({
                firstName: user.firstName || '',
                lastName: user.lastName || '',
                secondName: user.secondName || '',
                email: user.email || '',
                phone: user.phone || '',
                birthDate: user.birthDate || '',
                insuranceCompany: user.insuranceCompany || '',
            });
        }
    }, [user]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        console.log('Submitted data:', formData);
        setEditMode(false);
    };

    const fieldLabels: Record<keyof typeof formData, string> = {
        firstName: 'Имя',
        lastName: 'Фамилия',
        secondName: 'Отчество',
        email: 'E-Mail',
        phone: 'Телефон',
        birthDate: 'Дата рождения',
        insuranceCompany: 'Страховая компания',
    };

    return (
        <div className="profile-page profile-page_info">
            {editMode ? (
                <form className="profile-page__inner bionmax_account_edit_form" onSubmit={handleSubmit}>
                    <div className="profile-page__avatar-wrapper">
                        <div className="profile-page__avatar profile-page-avatar">
                            <div className="profile-page-avatar__image-wrapper">
                                <img src="/img/default-avatar.jpg" alt="avatar" />
                            </div>
                            <label className="profile-page-avatar__change profile-page-avatar-change">
                                <input
                                    name="ava"
                                    className="profile-page-avatar-change__input"
                                    type="file"
                                    accept=".jpg, .jpeg, .png"
                                />
                                <div className="profile-page-avatar-change__button">
                                    <svg className="svg-icon">
                                        <use href="/img/sprite-icons.svg#camera-fill"></use>
                                    </svg>
                                </div>
                            </label>
                        </div>
                    </div>

                    <div className="profile-page__content-wrapper">
                        <header className="profile-page__header">
                            <h1 className="title profile-page__title">Мои данные</h1>
                        </header>

                        <div className="profile-page__content">
                            <div className="form__grid">
                                {Object.keys(fieldLabels).map((field) => (
                                    <div className="form__col" key={field}>
                                        <label className="input__label input-label">{fieldLabels[field as keyof typeof formData]}</label>
                                        <label className="text-input">
                                            <input
                                                name={field}
                                                className="text-input__input"
                                                type="text"
                                                value={formData[field as keyof typeof formData]}
                                                onChange={handleChange}
                                            />
                                        </label>
                                    </div>
                                ))}
                            </div>

                            <div className="profile-page__save">
                                <button className="profile-page__save-link pointer" type="submit">
                                    Сохранить
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            ) : (
                <div className="profile-page__inner bionmax_account_edit_form">
                    <div className="profile-page__avatar-wrapper">
                        <div className="profile-page__avatar profile-page-avatar">
                            <div className="profile-page-avatar__image-wrapper">
                                <img src="/img/default-avatar.jpg" alt="avatar" />
                            </div>
                        </div>
                    </div>

                    <div className="profile-page__content-wrapper">
                        <header className="profile-page__header">
                            <h1 className="title profile-page__title">Мои данные</h1>
                        </header>

                        <div className="profile-page__content">
                            <div className="profile-page__fields-grid">
                                {Object.keys(fieldLabels).map((field) => (
                                    <div className="profile-page__fields-col" key={field}>
                                        <dl className="profile-page-field">
                                            <dt className="profile-page-field__title">{fieldLabels[field as keyof typeof formData]}</dt>
                                            <dd className="profile-page-field__value">
                                                {formData[field as keyof typeof formData] || '—'}
                                            </dd>
                                        </dl>
                                    </div>
                                ))}
                            </div>

                            <div className="profile-page__edit">
                                <button
                                    type="button"
                                    className="profile-page__edit-link profile-page-edit-link"
                                    onClick={() => setEditMode(true)}
                                >
                                    <svg className="svg-icon profile-page-edit-link__icon">
                                        <use href="/img/sprite-icons.svg#pencil-fill"></use>
                                    </svg>
                                    <span className="profile-page-edit-link__text">Изменить</span>
                                </button>
                                <a
                                    className="profile-page__edit-link profile-page-edit-link clean-cash-button"
                                    onClick={() => window.location.reload()}
                                >
                                    <img className="img-cleav-cash" src="/img/delete-folder.png" alt="" />
                                    <span className="profile-page-edit-link__text">Очистить кэш</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AccountInfoTab;
